const ADD_PLUS_LENGTH = 10;
const ADD_PLUS_ICON_WIDTH = 2;
const SWATCH_DIAMETER = 20;
const SWATCH_TAP_TARGET_DIAMETER = 33;
const N_SWATCHES = 4;

export {
  ADD_PLUS_LENGTH,
  ADD_PLUS_ICON_WIDTH,
  SWATCH_DIAMETER,
  N_SWATCHES,
  SWATCH_TAP_TARGET_DIAMETER,
};
